import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/lib/providers";
import Navbar from "./Navbar";
import Footer, { WhatsAppFab } from "./Footer";

export const FullLoader = () => (
  <div className="min-h-[60vh] grid place-items-center" data-testid="page-loader">
    <Loader2 className="animate-spin text-[var(--kh-violet)]" size={36} />
  </div>
);

export const RequireAuth = ({ admin = false, children }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <FullLoader />;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
};

export const PublicLayout = () => (
  <div className="kh-theme min-h-screen flex flex-col">
    <Navbar />
    <main className="flex-1"><Outlet /></main>
    <Footer />
    <WhatsAppFab />
  </div>
);
